export const SET_AUTOLOGIN = 'SET_AUTOLOGIN'
export const GET_AUTOLOGIN = 'GET_AUTOLOGIN'
export const RECEIVED_AUTOLOGIN = 'RECEIVED_AUTOLOGIN'



// WEBPACK FOOTER //
// ./src/store/modules/autologin/mutation-types.js